import { useEffect, useState, useRef } from 'react'
import { Modal, Button, Input } from 'antd'
import { CloseOutlined, } from '@ant-design/icons';
import style from './index.module.scss'
import * as apis from '../../api/networkDisk'
import useStore from '../../store/useStore'
import { deepCopy } from '../../util';
import { StorageModule } from "../../modules/storage";
import TaskTagPop from '../../components/memos/taskTagPop';
import MarkDownPop from '../../components/memos/markDownPop';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import ModelScreen from './modelScreen';

const { TextArea } = Input;
interface State {
    txtStr: any
}
interface Props {
    visible?: any
    onClose?: () => void;
    onRefresh?: () => void;
    onClick?: (i: any) => void;
    saveNode?: (i: any, txt: any,) => void;
    txt?: any;
    isAdd?: any;
    operationType?: any;
    change?: (i: any) => void;
    openVisible?: any

}

const MemoModal = (props: Props) => {
    const { store, dispatch } = useStore();
    const [operationName, setOperationName] = useState<any>('');
    const [txt, setTxt] = useState<any>('');
    const inputRef = useRef<any>()
    const [memoVisible, setMemoVisible] = useState<any>(false);


    const [state, setState] = useState<State>({
        txtStr: ''
    })
    const setMemoModal = (e: any) => {
        dispatch({
            type: 'SET_MEMOMODAL',
            data: e
        });
        props.onClose && props.onClose()
    }
    useEffect(() => {
        //便签注释自动聚焦
        console.log('store.myEditMemo?.data?.content', store.myEditMemo?.data?.content)
        if (memoVisible) {
            console.log(props.isAdd)
            if (!store.myEditMemo?.data?.content) {
                setTxt('')
                state.txtStr = ""
            } else {
                setTxt(store.myEditMemo?.data?.content)
                state.txtStr = store.myEditMemo?.data?.content
            }
            setState(state)
            setTimeout(() => {
                inputRef.current.focus({
                    cursor: 'end',
                });
            }, 500);
        } else {
            setTxt('')
            state.txtStr = ''
            setState(state)
        }
    }, [memoVisible, inputRef])
    // useEffect(() => {
    //     //有的页面因为重复引用，所以不需要store管理，再次进行判断，openVisible=true则是单独控制openVisible=false或不传则有store统一管理
    //     if (props.openVisible) {
    //         setMemoVisible(props.visible)
    //     } else {
    //         setMemoVisible(store.memoModal)
    //     }
    // }, [props.openVisible, props.visible, store.memoModal])
    useEffect(() => {
        console.log('setMemoVisible', store.memoModal)
        setMemoVisible(store.memoModal)
    }, [store.memoModal,])

    useEffect(() => {
        console.log('props.operationType', props.operationType)
        if (props.operationType === 'memos') {
            setOperationName('便签')
        } else if (props.operationType === 'comments') {
            setOperationName('注释')
        } else if (props.operationType === 'relationBelongTos') {
            setOperationName('关系说明')
        }
    }, [props.operationType])
    // useEffect(() => {
    //     setTxt(props.txt)
    // }, [props.txt])
    useEffect(() => {
        console.log(state.txtStr)
    }, [state.txtStr])

    return (
        <>
            <div data-flex='main:justify cross:center' className='mb-10'>
                <>{console.log(props.isAdd, operationName, props.operationType)}</>
                <ModelScreen name={<div>{operationName}</div>} />

                <Button className='btn mr-20' key='btn1' type="primary" onClick={() => {
                    props.change && props.change(state.txtStr)
                    // state.txtStr = props.txt
                    // setState(state)
                    console.log('state.txtStr', state.txtStr, props.operationType)
                    if (props.operationType === 'comments') {
                        props.saveNode && props.saveNode('comments', state.txtStr)
                    } else if (props.operationType === 'relationBelongTos') {
                        props.saveNode && props.saveNode('relationBelongTos', state.txtStr)
                    } else {
                        props.saveNode && props.saveNode('memos', state.txtStr)
                    }
                    props.onClose && props.onClose()
                }}>保存{operationName}</Button>
            </div>
            <TextArea rows={6} style={{ height: "calc(95vh - 47px)", resize: 'none' }} placeholder={`请输入${operationName}内容`} defaultValue={store.myEditMemo?.data?.content} ref={inputRef} value={txt} onChange={(e) => {
                console.log('95state.txtStr', state.txtStr)
                setTxt(e.target.value)
                state.txtStr = e.target.value
                setState(state)
                dispatch({
                    type: 'SET_MYEDITMEMO',
                    data: { ...store.myEditMemo, content: e.target.value, data: { ...store.myEditMemo.data, content: e.target.value } }
                });
            }} onPressEnter={() => {
            }} />

        </>
    )
}

export default MemoModal